import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

// «essere или avere?» — выбор вспомогательного глагола; после ответа показываем правило и пример.
export default function AuxCard({ card, result, onPick, disabled, t }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary">{t('study.auxTitle')}</Typography>
      <Typography variant="h5" sx={{ fontWeight: 600 }}>{card.infinitive}</Typography>
      <Typography variant="body2" color="text.secondary">{card.gloss}</Typography>
      {!result ? (
        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
          {card.options.map((o) => (
            <Button key={o} variant="outlined" sx={{ flex: 1 }} disabled={disabled} onClick={() => onPick(o)}>
              {o === 'both' ? t('study.auxBoth') : o}
            </Button>
          ))}
        </Stack>
      ) : (
        <Alert severity="info" icon={false} sx={{ mt: 2 }}>
          <Typography variant="body2">{t(`study.auxReason.${result.aux_reason}`)}</Typography>
          {card.example && (
            <Typography variant="body2" sx={{ mt: 0.5 }}>{t('study.auxExample', { ex: card.example })}</Typography>
          )}
        </Alert>
      )}
    </Box>
  );
}
